import { Button, Error, WebpageMagnifyingGlass } from '@intigral/shared';
import { Link, useNavigate } from 'react-router-dom';
import h from '../helpers/common';
import { __ } from '../translations';
import { useSelector } from 'react-redux';
import { IStore } from '../interfaces/StoreTypes';

type NotFoundScreenProps = {
    screenName: string;
    screenKey: string;
};

export const NotFoundScreen: React.FC<NotFoundScreenProps> = () => {
    const { selectedProfile } = useSelector((state: IStore) => state.profile);
    const navigate = useNavigate();
    const redirectLink = () => {
        const isKids = selectedProfile?.kidsMode;
        const lang = h.getLang();
        if (isKids) {
            navigate(lang === 'en' ? '/en/kids-home' : '/kids-home');
        } else {
            navigate(lang === 'en' ? '/en' : '/');
        }
    };
    return (
        <Error
            icon={<WebpageMagnifyingGlass />}
            errorPairs={[
                {
                    title: __('not_found_title'),
                    text: __('not_found_description'),
                },
            ]}
        >
            <Button primary compact onClick={redirectLink}>
                {__('go_to_homepage')}
            </Button>
        </Error>
    );
};
